
import download from 'downloadjs';
import mime from 'mime';

function useDownload() {
  const downloadBySiteFileId = (siteFileId, fileName) => {
    const downloadLink = `/common/downloadFileSite?siteFileId=${siteFileId}`;
    fetch(downloadLink)
      .then((res) => {
        let contentBuffer = new Int8Array();

        const reader = res.body.getReader();

        const handleChunk = ({ done, value }) => {
          if (done) {
            const mimeType = mime.getType(fileName);
            download(contentBuffer, fileName, mimeType);
            return;
          }

          contentBuffer = Int8Array.from([...contentBuffer, ...value]);

          reader.read().then(handleChunk);
        };

        reader.read().then(handleChunk);
      })
      .catch((err) => console.error(err));
  }

  return {
    downloadBySiteFileId
  };
}

export default useDownload;
